import { render, staticRenderFns } from "./MakeMoldEdit.vue?vue&type=template&id=bc0c10d6"
import script from "./MakeMoldEdit.vue?vue&type=script&lang=js"
export * from "./MakeMoldEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports